export const useLayoutStyle = () => useState<string | null>("layout-style", () => null)
